export const PROBLEM_TYPE_ALL = "all";
export const PROBLEM_TYPE_VALUES = [1, 2];
export const DEFAULT_PROBLEM_TYPE_VALUE = 1;

export const isProblemTypeAll = (value) =>
  value === PROBLEM_TYPE_ALL || value === null || value === undefined;

export const normalizeProblemTypeFilterValue = (value) => {
  if (isProblemTypeAll(value)) return PROBLEM_TYPE_ALL;
  const numeric = Number(value);
  return PROBLEM_TYPE_VALUES.includes(numeric) ? numeric : PROBLEM_TYPE_ALL;
};

export const resolveProblemTypeValue = (
  value,
  fallback = DEFAULT_PROBLEM_TYPE_VALUE,
) => {
  const numeric = Number(value);
  return PROBLEM_TYPE_VALUES.includes(numeric) ? numeric : fallback;
};
